/**
 * SignalR connection status indicator dot for the header.
 * Green = connected, Amber = reconnecting, Red = disconnected.
 */

import { cn } from "@/lib/utils";
import {
  useSignalRState,
  type SignalRConnectionState,
} from "@/providers/signalr-provider";

const STATE_STYLES: Record<SignalRConnectionState, string> = {
  connected: "bg-sc-success",
  reconnecting: "bg-sc-warning animate-sc-pulse",
  disconnected: "bg-sc-error",
};

const STATE_LABELS: Record<SignalRConnectionState, string> = {
  connected: "Real-time connection active",
  reconnecting: "Reconnecting to server...",
  disconnected: "Real-time connection lost",
};

export function SignalRIndicator() {
  const state = useSignalRState();

  return (
    <div
      className={cn("h-2.5 w-2.5 rounded-full", STATE_STYLES[state])}
      title={STATE_LABELS[state]}
      aria-label={STATE_LABELS[state]}
      role="status"
    />
  );
}
